import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  ChatModel,
  ChatsState,
  ChatState,
  IPossibleConversation,
  WebSocketChatsEventResponse,
} from '../models/chat.model';
import { WebsocketService } from '@shared/services/websocket/websocket.service';
import { Response } from '@shared/models/response.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatService {
  public currentChatID$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public currentChatsUnViewedMessages$: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  public currentChatsState$: BehaviorSubject<ChatsState> =
    new BehaviorSubject<ChatsState>({
      chats: [],
      requested_chats: [],
    });

  public currentChatState$: BehaviorSubject<ChatState> =
    new BehaviorSubject<ChatState>({
      chat: {} as ChatModel,
      chat_messages: [],
      linked_data: [],
    });

  constructor(
    private readonly httpClient: HttpClient,
    private webSocketService: WebsocketService
  ) {
    this.webSocketService.on(
      'getUnViewedMessagesOfChats',
      (response: WebSocketChatsEventResponse) => {
        this.currentChatsUnViewedMessages$.next(response.data as number);
      },
      'chat'
    );
  }

  public getPossibleConversation(
    text: string,
    marker?: string
  ): Observable<IPossibleConversation[]> {
    return this.httpClient
      .get<Response<IPossibleConversation[]>>(
        `${environment.apiUrl}/chat/conversations`,
        {
          params: {
            text,
            ...(marker ? { marker } : {}),
          },
        }
      )
      .pipe(map((response) => response.data));
  }

  public sendMessage(chat_id: string, message: string): void {
    this.webSocketService.emit(
      'sendMessage',
      {
        chat_id: chat_id,
        message: message,
      },
      'chat'
    );
  }

  public markMessageAsReaded(chat_id: string, messages: string[]): void {
    this.webSocketService.emit(
      'markMessageAsReaded',
      {
        chat_id: chat_id,
        messages: messages,
      },
      'chat'
    );
  }

  public acceptRequestedChat(chat_id: string): void {
    this.webSocketService.emit('acceptChatRequest', chat_id, 'chat');
  }

  public changeChatStatus(chat_id: string, status: string): void {
    this.webSocketService.emit('changeChatStatus', { chat_id, status }, 'chat');
  }
}
